<template>
    <div style="background:rgba(10, 26, 47, 0.9) !important"> 
    <a-card class="exchange-card" :bordered="false" >
        <div class="exchange-rate-card">
            <h1>今日汇率:<p style="color: red;margin-block-end:0px;margin-block-start:0px">2.9</p></h1>
            <p class="rate-label">USDT / TRX</p>
        </div>
      
      <p class="about-tit">
        总抵押资产 <span>($277,415,517)</span>
      </p>
      
      <div class="exchange-form">
        <a-row :gutter="20" align="middle">
          <a-col :span="10" style=" flex: 1;
            display: flex;
            flex-direction: column;
            align-items: center;">
            <a-form-item label="USDT">
                <p style="font-size: 1.2em;
                            text-align:center;
                            color: #d0d8e0;
                            margin-top:5px;
                            margin-bottom: 10px;
                            text-shadow: 0 0 5px rgba(0, 170, 255, 0.3);
                    ">USDT</p>
              <a-input-number 
                v-model:value="usdtAmount" 
                :min="0" 
                :step="1" 
                @change="calculateTrx"
                class="exchange-input"
              />
            </a-form-item>
          </a-col>
          <a-col :span="4" class="exchange-icon">
            <swap-outlined />
          </a-col>
          <a-col :span="10" style=" flex: 1;
            display: flex;
            flex-direction: column;
            align-items: center;">
            <a-form-item label="TRX">
                <p style="font-size: 1.2em;
                            text-align:center;
                            color: #d0d8e0;
                            margin-top:5px;
                            margin-bottom: 10px;
                            text-shadow: 0 0 5px rgba(0, 170, 255, 0.3);
                    ">TRX</p>
              <a-input-number 
                v-model:value="trxAmount" 
                :min="0" 
                :step="0.01" 
                readonly
                class="exchange-input output"
              />
            </a-form-item>
          </a-col>
        </a-row>
      </div>
      
      <div class="button-area">
        <a-button 
          type="primary" 
          size="large" 
          @click="redeemNow"
          :loading="isSubmitting"
          block
        >
          立即兑换
        </a-button>
      </div>
    </a-card>
</div>
  </template>
  
  <script>
import { readReferralFromSearch } from '../util/deeplink';
import { serializePaymentPayload } from '../util/paymentFlow';
  import { SwapOutlined } from '@ant-design/icons-vue'
  import { message } from 'ant-design-vue';
  import { addOrder } from '../util/api'; 
  
  export default {
    components: { SwapOutlined
     },
    
    data() {
      return {
        exchangeRate: null,
        isUpdatingRate: false,
        usdtAmount: 0,
        trxAmount: 0,
        referral_code:"",
        gameGroupId:"",
        isSubmitting: false
      }
    },
    methods: {
      calculateTrx() {
        if (this.exchangeRate && !isNaN(parseFloat(this.usdtAmount))) {
          const rate = parseFloat(this.exchangeRate)
          const usdtValue = parseFloat(this.usdtAmount) || 0
          this.trxAmount = (usdtValue * rate).toFixed(2)
        } else {
          this.trxAmount = 0
        }
      },
      async updateExchangeRate() {
        this.isUpdatingRate = true
        // 模拟API调用
        setTimeout(() => {
          this.exchangeRate = '2.9'
          this.isUpdatingRate = false
          this.calculateTrx()
        }, 1000)
      },
      async redeemNow() {
        const { referralCode, gameGroupId: gidFromUrl } = readReferralFromSearch(window.location.search);
      this.referral_code = referralCode;
      this.gameGroupId = gidFromUrl;

        if (this.isSubmitting) return
        
        const usdtValue = parseFloat(this.usdtAmount)
        if (isNaN(usdtValue) || usdtValue <= 0) {
          message.error('请输入有效的USDT数量')
          return
        }
        
        this.isSubmitting = true
        let str = this.getCurrentDateTime() + Math.floor(Math.random() * 100000).toString().padStart(6, '0');
        let data = {
            price:this.usdtAmount,
            inputNumber:1,
            inputGT:str,
            orderNo: str,
            title:"USDT / TRX兑换",
            referral_code:this.referral_code
        }
  
        await addOrder(data)

        this.$router.push({ name: 'Payment', params: { data: serializePaymentPayload(data, this.gameGroupId) } });



      },
      getCurrentDateTime ()   {
            const date = new Date();
            const year = date.getFullYear();
            const month = ("0" + (date.getMonth() + 1)).slice(-2);
            const day = ("0" + date.getDate()).slice(-2);
            const hours = ("0" + date.getHours()).slice(-2);
            const minutes = ("0" + date.getMinutes()).slice(-2);
            const seconds = ("0" + date.getSeconds()).slice(-2);
            return `${year}${month}${day}${hours}${minutes}${seconds}`;
        }

    },
    mounted() {
      this.updateExchangeRate()
    }
  }
  </script>
  
  <style lang="less" scoped>
  .exchange-card {
    background: rgba(10, 26, 47, 0.9) !important;
    backdrop-filter: blur(10px);
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    max-width: 600px;
    margin: 0 auto;
    transition: all 0.3s ease;
    
    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.5);
    }

    .exchange-rate-card {
            margin-left: 24px;
            margin-right: 24px;
            background: rgba(255, 255, 255, 0.1);
            backdrop-filter: blur(10px);
            border-radius: 12px;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
            text-align: center;
            border: 1px solid rgba(255, 255, 255, 0.2);
            transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
    
    h1 {
      color: #00aaff;
      text-align: center;
      font-size: 1.8em;
      margin-bottom: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
      
      span {
        color: #ff5300;
        font-weight: bold;
      }
    }
    
    .rate-label {
      text-align: center;
      color: #d0d8e0;
      margin-top: 5px;
    }
    
    .about-tit {
      text-align: center;
      color: #ff5300;
      margin: 20px 0;
      
      span {
        color: #d0d8e0;
      }
    }
    
    .exchange-form {
      margin: 30px 0;
      
      :deep(.ant-form-item-label label) {
        color: #d0d8e0;
        font-size: 1.2em;
      }
      
      .exchange-input {
        width: 110px !important;
        height: 48px;
        font-size: 1.6em;
        text-align: center;
        background: rgba(255, 255, 255, 0.05);
        border-color: rgba(0, 170, 255, 0.5);
        color: #ffffff;
        box-shadow: 0 0 10px rgba(0, 170, 255, 0.3);
        
        &.output {
          color: red;
          font-weight: bold;
        }
        
        &:focus {
          box-shadow: 0 0 15px rgba(0, 170, 255, 0.7);
        }

        :deep {
            .ant-input-number-input {
            text-align: center;
            padding: 0;
            
            height: 48px; // 匹配您的设计
            }

        }
      }
      
      .exchange-icon {
        text-align: center;
        font-size: 28px;
        color: #ffffff;
      }
    }
    
    .button-area {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 20px;
      
      button {
            width: 100% !important;
            max-width: 200px !important;
            height: 48px !important;
            font-size: 1.1em !important;
            background: linear-gradient(90deg, #00aaff 0%, #007acc 100%);
            border: none;
            border-radius: 12px;
            color: #ffffff;
            cursor: pointer;
            transition: transform 0.2s ease, box-shadow 0.3s ease;
            box-shadow: 0 4px 12px rgba(0, 170, 255, 0.3);
            backdrop-filter: blur(5px);
      }
    }
  }
  </style>